module.exports = __webpack_public_path__ + "img/separator1.45c2bafe.svg";